(function () {
  'use strict';

  var PIXEL_DISPATCH_DELAY_MS = 1000;
  var checkoutRedirectPending = false;

  function checkoutUrl(routesRoot) {
    var root = routesRoot || '/';
    return root.slice(-1) === '/' ? root + 'checkout' : root + '/checkout';
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !checkoutRedirectPending) return;
    checkoutRedirectPending = false;
    window.location.reload();
  });

  window.NutraFunnelCheckout = window.NutraFunnelCheckout || {};
  window.NutraFunnelCheckout.redirectAfterCartAdd = function (routesRoot) {
    checkoutRedirectPending = true;
    window.setTimeout(function () {
      window.location.assign(checkoutUrl(routesRoot));
    }, PIXEL_DISPATCH_DELAY_MS);
  };
}());
